<div *ngIf="dataNews" class="container-general-small p-md-2 h-100 no-print" [ngClass]="{'p-1 p-md-0': isNews}">
    <div class="container-general-small__container-image position-relative">
        <img loading="lazy" *ngIf="dataNews.field_immagine" [src]="imgPath"
            class="container-general-small__container-image__image h-100 w-100" [alt]="image_alt">
        <img loading="lazy" *ngIf="dataNews.field_immagine_importata" [src]="domainWebsite + dataNews.field_immagine_importata"
            class="container-general-small__container-image__image h-100 w-100" [alt]="'Event | Lumsa'">
        <img loading="lazy" *ngIf="!dataNews.field_immagine && !dataNews.field_immagine_importata"
            src="./assets/images/rectangle_gradient.png" alt="'Event | Lumsa'" class="w-100">
        <div *ngIf="dataNews.field_created_at"
            class="container-general-small__container-image__badge ls-label-small-semibold text-neutral-A1 bg-support-50 position-absolute top-0 left-0">
            {{dataNews.field_created_at | localizedDate: 'd MMMM yyyy'}}
        </div>
        <div *ngIf="dataNews.created"
            class="container-general-small__container-image__badge ls-label-small-semibold text-neutral-A1 bg-support-50 position-absolute top-0 left-0">
            {{dataNews.created | localizedDate: 'd MMMM yyyy'}}
        </div>
    </div>
    <div class="container-general-small__container-description bg-neutral-A1 d-flex flex-column justify-content-between">
        <div class="container-general-small__container-description__container-text">
            <div
                class="container-general-small__container-description__container-text__container-tags d-flex justify-content-between align-items-start">
                <div class="container-general-small__container-description__container-text__container-tags__tags">
                    <p class="text-neutral-60 ls-label-small-semibold m-0 text-uppercase" *ngIf="stringTaxonomies"
                        [innerHTML]="stringTaxonomies"></p>
                </div>
                <!-- <div class="container-general-small__container-description__container-text__container-tags__share">
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
                </div> -->
            </div>
            <div class="container-general-small__container-description__container-text__text">
                <a *ngIf="objTitle && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
                    <p class="text-brand-10 mb-3 text-decoration-none ls-h3-item-title-small cursor-pointer"
                        [hreflang]="objTitle.hreflang" [innerHTML]="objTitle.title"></p>
                </a>
                <a *ngIf="objTitle && isLinkEsternal" [href]="objTitle.link">
                    <p class="text-brand-10 mb-3 text-decoration-none ls-h3-item-title-small cursor-pointer"
                        [hreflang]="objTitle.hreflang" [innerHTML]="objTitle.title"></p>
                </a>
                <p *ngIf="dataNews.field_sottotitolo && !isNews" class="text-neutral-40 ls-p-small d-none d-lg-block"
                    [innerHTML]="dataNews.field_sottotitolo"></p>
            </div>
        </div>
        <a *ngIf="objTitle && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
            <div class="container-general-small__container-description__button-bottom">
                <div
                    class="m-0 ls-label-medium-semibold container-general-small__container-description__button-bottom__button text-brand-40 line-discover-with-icon">
                    <p class="ls-label-medium-semibold text-uppercase">{{"FIND_OUT" | translate}}</p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </div>
        </a>
        <a *ngIf="objTitle && isLinkEsternal" [href]="objTitle.link">
            <div class="container-general-small__container-description__button-bottom">
                <div
                    class="m-0 ls-label-medium-semibold container-general-small__container-description__button-bottom__button text-brand-40 line-discover-with-icon">
                    <p class="ls-label-medium-semibold text-uppercase">{{"FIND_OUT" | translate}}</p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </div>
        </a>
    </div>
</div>
<app-sample-print *ngIf="dataNews" 
    [imageUrl]="dataNews.field_immagine ? imgPath : dataNews.field_immagine_importata ? domainWebsite + dataNews.field_immagine_importata : ''" 
    [date]="dataNews.field_created_at" 
    [title]="objTitle.title" 
    [taxonomy]="stringTaxonomies">
</app-sample-print>